// Influencer page urls
export const INFLUENCER_LANDING_PAGE = '/influencer-home';
export const INFLUENCER_ENROLL_PENDING = '/influencer/enroll/pending';
export const INFLUENCER_ENROLL_DECLINE = '/influencer/enroll/decline';
export const INFLUENCER_ENROLL_SUCCESS_PAGE = '/influencer/enroll/success';
export const INFLUENCER_ADD_PROFILE_CALLBACK_PAGE = '/influencer/callback';
export const INFLUENCER_SIGNUP_PAGE = '/influencer/signup';
export const INFLUENCER_ELIGIBILITY_PAGE = '/influencer/eligibility';
export const INFLUENCER_HUB_PAGE = '/influencer/hub';
export const INFLUENCER_ENROLL_CALLBACK = '/influencer/enroll';
export const INFLUENCER_SHOPPABLE_POST = '/influencer/hub/shoppablePost/';

export const INFLUENCER_PAGES_DETAILS = {
  [INFLUENCER_LANDING_PAGE]: {
    pageName: 'influencer-home',
    isLandingPage: true,
    needsAuthentication: false
  },
  [INFLUENCER_SIGNUP_PAGE]: {
    pageName: 'influencer-enroll',
    isLandingPage: false,
    needsAuthentication: false
  },
  [INFLUENCER_ENROLL_SUCCESS_PAGE]: {
    pageName: 'influencer-enroll-success',
    isLandingPage: false,
    needsAuthentication: true
  },
  [INFLUENCER_ELIGIBILITY_PAGE]: {
    pageName: 'influencer-eligibility',
    isLandingPage: false,
    needsAuthentication: true
  },
  [INFLUENCER_ENROLL_PENDING]: {
    pageName: 'influencer-enroll-pending',
    isLandingPage: false,
    needsAuthentication: true
  },
  [INFLUENCER_ENROLL_DECLINE]: {
    pageName: 'influencer-enroll-decline',
    isLandingPage: false,
    needsAuthentication: true
  }
};

export const INFLUENCER_MSA_FOLDER_PATH = 'https://m.media-amazon.com/images/G/01/zappos/zip/';
export const COLLECTION_DESCRIPTION_PROMPTS = [
  'What\'s your concept for this collection?',
  'How should your followers wear them?',
  'What occasion is this collection for?'
];
export const DESCRIPTION_PROMPT_DURATION_SECONDS = 20;
export const INFLUENCER_PROFILE_TAB = 'INFLUENCER_PROFILE_TAB';
export const INFLUENCERS_COLLECTIONS_TAB = 'INFLUENCER_COLLECTIONS_TAB';
export const INFLUENCER_PUBLISHED_COLLECTIONS = 'INFLUENCER_PUBLISHED_COLLECTIONS';
export const INFLUENCER_ALL_COLLECTIONS = 'INFLUENCER_ALL_COLLECTIONS';
export const INFLUENCER_SHARED_COLLECTIONS = 'INFLUENCER_SHARED_COLLECTIONS';
export const INFLUENCER_HIDDEN_COLLECTIONS = 'INFLUENCER_HIDDEN_COLLECTIONS';
export const INFLUENCER_READY_TO_SHARE_COLLECTIONS = 'INFLUENCER_READY_TO_SHARE_COLLECTIONS';
export const INFLUENCER_PENDING_REVIEW_COLLECTIONS = 'INFLUENCER_PENDING_REVIEW_COLLECTIONS';
export const INFLUENCER_DECLINED_COLLECTIONS = 'INFLUENCER_DECLINED_COLLECTIONS';
export const INFLUENCER_NEW_COLLECTION_DAYS = 30;
export const STOREFRONT_CUSTOMER_VIEW = 'STOREFRONT_CUSTOMER_VIEW';
